import(/* webpackMode: "eager", webpackExports: ["FAQJsonLd"] */ "/Users/gopal/BlindsCode/blindscommerce/components/seo/JsonLd.tsx");
